import {useInfiniteQuery} from 'react-query';
import useInfiniteScroll from '../../../utilities/hooks/useInfiniteScroll';
import {getShopAdvertisementsByInput} from './getShopAdvertisementsByInput';
import {IShopAdvertisementsPayload} from './types';

const UseGetShopAdvertisementsByInput = (
  payload?: IShopAdvertisementsPayload,
) => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ['get-shop-advertisements-by-input', payload],
    async ({pageParam = 1}) =>
      getShopAdvertisementsByInput({pageParam, payload}),
    {
      enabled: payload?.enabled ?? true,
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage.next) return undefined;
        return allPages.length + 1;
      },
    },
  );

  const data = rawData?.pages.flatMap(page => page.results);

  const loaderRef = useInfiniteScroll({
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return {
    data,
    isLoading,
    loaderRef,
    isFetchingNextPage,
  };
};

export default UseGetShopAdvertisementsByInput;
